export default class windowManipulationService {
    static isBrowserEnvironment() {
        return typeof window !== 'undefined';
    }
}
